import script from "./_ItemEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./_ItemEdit.vue?vue&type=script&setup=true&lang=js"

import "./_ItemEdit.vue?vue&type=style&index=0&id=7ee964d2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee964d2"]])

export default __exports__